<template>
     <div class="serviceprovider-search">
          <PageTitle icon="fa fa-clone" main="Record" sub="Service Provider" />
            <b-form v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input id="serviceprovider-id" type="hidden" v-model="serviceprovider.id" />
             <b-row>
                <b-col md="5" sm="12">
                    <b-form-group 
                        label="Name:" 
                        label-for="serviceprovider-name_service_provider">
                        <b-form-input 
                            id="serviceprovider-name_service_provider" 
                            type="text" 
                            ref="searchFocus"
                            v-model="serviceprovider.name_service_provider" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Name..." />
                    </b-form-group>
                </b-col>   
                <b-col md="3" sm="12">
                    <b-form-group 
                        label="ID:" 
                        label-for="serviceprovider-doc_identification_service_provider">    
                        <b-form-input
                            id="serviceprovider-doc_identification_service_provider" 
                            type="text"
                            v-model="serviceprovider.doc_identification_service_provider" 
                            required
                            size="sm"
                            :readonly="true"
                            placeholder="ID..." />  
                    </b-form-group>
                </b-col>
                 <!--b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="serviceprovider.physical_person_service_provider" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="serviceprovider-physical_person_service_provider"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="serviceprovider-physical_person_service_provider">
                                Physical Person?
                            </label>
                        </div>
                    </div>
                </b-col-->  
                <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="serviceprovider.blocked_service_provider" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="serviceprovider-blocked_service_provider"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="serviceprovider-blocked_service_provider">
                                Blocked?
                            </label>
                        </div>
                    </div>
                </b-col>  
              
             </b-row>
             <b-row>
                <b-col md="6" sm="12">
                    <b-form-group 
                        label="E-mail:" 
                        label-for="serviceprovider-email_service_provider">
                        <b-form-input 
                        id="serviceprovider-email_service_provider" 
                        type="email"
                        v-model="serviceprovider.email_service_provider" 
                        size="sm"
                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        placeholder="E-mail" />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <b-form-group 
                        label="Phone number:" 
                        label-for="serviceprovider-phone_number_service_provider">
                        <b-form-input 
                            id="serviceprovider-phone_number_service_provider" 
                            type="text"
                            v-model="serviceprovider.phone_number_service_provider" 
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Phone number" />
                    </b-form-group>
                </b-col>
                 <b-col md="2" sm="12">
                    <b-form-group
                    label="Birth Date:"
                    label-for="serviceprovider-birth_date_service_provider"
                    >
                    <b-form-input
                    id="serviceprovider-birth_date_service_provider"
                    type="date"
                    v-model="serviceprovider.birth_date_service_provider"
                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
             </b-row>
            <b-card class="owner-search-card">
                    <b-tabs card vertical >
                     <b-tab title="Acting Service" active> 
                        <b-row>
                        <b-button  
                            title="Add Service" 
                            size="sm" 
                            class="mb-2 fa fa-plus" 
                            variant="dark" 
                            v-if="serviceprovider.id > 0"
                            @click="openModalActingService">
                        </b-button>
                        </b-row>
                        <b-row>
                              <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :items="serviceprovideractingservices" 
                            :fields="fieldActingService">
                        <template v-slot:cell(actions)="data">
                            <b-button 
                                title="Delete" 
                                size="sm" 
                                variant="light" 
                                @click="showMsgBoxDeleteActingService(data.item)" 
                                class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                            </b-button>
                        </template>
                        </b-table>
                        </transition>  
                        </b-row>
                        
                        </b-tab>
                    </b-tabs>
                </b-card>
        <br>
         </b-form>

            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadServiceProviders(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                   <div class="col-sm-4">
                    <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                            v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Search by provider name" 
                            class="form-control">
                    </div>
                </div>  
          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                     <b-button
                        v-if="!data.item.user_service_provider_id >0"  
                        title = "Create Login" 
                        size="sm" 
                        variant="light" 
                        @click="showMsgBoxCreateUser(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-user-circle"></i>
                    </b-button>
                    <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadServiceProvider(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadServiceProvider(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadServiceProvider(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
    </b-row>
        <b-modal
            id="modalActingService"
            ref="modal"
            title-tag="h6"
            title="Acting Service"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveActingService"
        >
            <b-form>
                <b-col md="12" sm="12">
                    <b-form-group 
                        label="Service:" 
                        label-for="serviceprovideractingservice-default_service_type_id_service_acting">
                        <b-select 
                            id="serviceprovideractingservice-default_service_type_id_service_acting"
                            size="sm"
                            :options="defaultservicetypes" 
                            v-model="serviceprovideractingservice.default_service_type_id_service_acting" 
                            />
                    </b-form-group>
                </b-col> 
            </b-form>
        </b-modal>
            
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'ServiceProviderSearch',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                serviceprovider: {},
                serviceprovideractingservice: {},
                serviceprovideractingservices:[],
                serviceproviders: [],
                defaultservicetypes: [],
                users: [],
                perPage: 5,
                currentPage: 1,
                isBusy: false,
                showTable: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                { key: 'name_service_provider', label: 'Name', sortable: true,variant: 'light' },
                { key: 'doc_identification_service_provider', label: 'ID', sortable: true ,variant: 'light'},
                { key: 'email_service_provider', label: 'E-mail', sortable: false ,variant: 'light'},   
                { key: 'phone_number_service_provider', label: 'Phone Number', sortable: false ,variant: 'light'},   
                { key: 'blocked_service_provider', label: 'Blocked', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},               
                { key: 'actions', label: 'Action',variant: 'light' },
                //{ key: 'accesses', label: 'Acessos',variant: 'secondary' }
                ],
                fieldActingService: [
                { key: 'name_default_service_type', label: 'Service', sortable: false ,variant: 'light'},   
                { key: 'actions', label: 'Action',variant: 'light' }
                ]
            }
        },
        computed: {
            filteredList() {
                return this.serviceproviders.filter(serviceprovider => {
                    return serviceprovider.name_service_provider.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.serviceproviders.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            formatDate(date) {
                return moment(date)
                    .format('YYYY-MM-DD')
            },
            formatDateTime(date) {
                return moment(date)
                    .format('YYYY-MM-DD LT')
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
               async showMsgBoxCreateUser(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to create login?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.createUserProvider(item)
                    }
                })
            },
            async showMsgBoxDeleteActingService(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeActingService(item)
                    }
                })
            },
             async createUserProvider(item){

                        this.serviceprovider = {...item}
                       if (!item.email_service_provider) {
                            this.$toasted.global.defaultError({ msg: 'Email not provided when registering..' })
                        }
                        if (!item.birth_date_service_provider) {
                            this.$toasted.global.defaultError({ msg: 'Date of birth not specified in registration...' })
                        }

                        let user_provider = {}

                        user_provider = {

                            name: item.name_service_provider,
                            email: item.email_service_provider,
                            company_default_id: this.compan.id,
                            blocked: 0,
                            service_provider:1,
                            password: moment(item.birth_date_service_provider).format('YYYY'),
                            confirmPassword: moment(item.birth_date_service_provider).format('YYYY')
                        }

                        if(item.email_service_provider && item.birth_date_service_provider){
                              axios.post(`${baseApiUrl}/signup`, user_provider)
                            .then(() => {
                                this.$toasted.global.defaultSuccess()
                                 this.getLastUserProvider()
                                //this.createMailLoginTenant(item.id)
                            })
                            .catch(showError)
                        }
                       
                },
                async getLastUserProvider() {
                const url = `${baseApiUrl}/serviceproviderbyuserid/${this.compan.id}/?name=${this.serviceprovider.name_service_provider}&email=${this.serviceprovider.email_service_provider}`;
                    await axios(url).then(
                        (res) =>
                        (this.serviceprovider = {
                            ...this.serviceprovider,
                            user_service_provider_id: res.data.id,
                        })
                    );

                    if(this.serviceprovider.user_service_provider_id > 0){
                        this.save()
                    }
                }, 
            loadServiceProviders(){
                const url = `${baseApiUrl}/serviceprovidersbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.serviceproviders = res.data
                      this.isBusy = false
                })
            },
            loadServiceProviderActingServices(){
                const url = `${baseApiUrl}/serviceprovideractingservicebyserviceprovider/${this.serviceprovider.id}`
                axios(url).then(res =>{
                     this.serviceprovideractingservices = res.data
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.serviceprovider = {}
                    this.serviceprovideractingservice = {}
                    this.serviceprovideractingservices = []
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.loadServiceProviders()
                this.serviceprovideractingservices = []
                this.serviceprovider = {}
            },
            async save() {

                const method = this.serviceprovider.id ? 'put' : 'post'
                const id = this.serviceprovider.id ? `/${this.serviceprovider.id}` : ''

                if(this.serviceprovider.id){
                    this.serviceprovider.update_date_service_provider = this.formatDateTime(Date())
                    this.serviceprovider.update_user_id_service_provider = this.user.id
                }else{
                    this.serviceprovider.user_id_service_provider = this.user.id
                    this.serviceprovider.company_id_service_provider = this.compan.id
                }

                await axios[method](`${baseApiUrl}/serviceproviders${id}`, this.serviceprovider)
                    .then(async () => {
                        this.$toasted.global.defaultSuccess()
                      // await this.createEntity(this.serviceprovider)
                        this.reset()
                    })
                    .catch(showError)
            },
          
            async saveActingService() {
                    if (this.serviceprovideractingservice.id) {
                        this.serviceprovideractingservice.update_user_id_service_acting = this.user.id
                        this.serviceprovideractingservice.update_date_service_acting = this.formatDateTime(Date())
                    } else {
                        this.serviceprovideractingservice.user_id_service_acting = this.user.id
                    }

                    const method = this.serviceprovideractingservice.id ? 'put' : 'post'
                    const id = this.serviceprovideractingservice.id ? `/${this.serviceprovideractingservice.id}` : ''
                    this.serviceprovideractingservice.service_provider_id_service_acting = this.serviceprovider.id
                    await axios[method](
                        `${baseApiUrl}/serviceprovideractingservices${id}`,
                        this.serviceprovideractingservice
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.serviceprovideractingservice = {}
                            this.loadServiceProviderActingServices()
                        })
                        .catch(showError)
            },
            remove() {
                    const id = this.serviceprovider.id
                    axios.delete(`${baseApiUrl}/serviceproviders/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
           async removeActingService(item) {
                     axios.delete(`${baseApiUrl}/serviceprovideractingservices/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadServiceProviderActingServices()
                        })
                        .catch(showError)
            },
            loadServiceProvider(serviceprovider, mode = 'save') {
                this.mode = mode
                this.serviceprovider = { ...serviceprovider }
                this.$refs.searchFocus.focus();
                this.loadServiceProviderActingServices()
                
            },
            loadServiceProviderActingService(item){
                this.serviceprovideractingservice = {...item}
            },
            openModalActingService() {
                this.$bvModal.show('modalActingService')
            },
            loadDefaultServiceRequests() {
                const url = `${baseApiUrl}/defaultservicetypesbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.defaultservicetypes = res.data.map(type => {
                        return { value: type.id, text: type.name_default_service_type }
                    })
                })
            },
              async createUserServiceProvider(item){

                        this.tenant = {...item}
                       if (!item.email_service_provider) {
                            this.$toasted.global.defaultError({ msg: 'Email not provided when registering..' })
                        }
                        if (!item.birth_date_service_provider) {
                            this.$toasted.global.defaultError({ msg: 'Date of birth not specified in registration...' })
                        }

                        let user_service_provider = {}

                        user_service_provider = {

                            name: item.name_service_provider,
                            email: item.email_service_provider,
                            company_default_id: this.compan.id,
                            blocked: 0,
                            service_provider:1,
                            password: moment(item.birth_date_service_provider).format('YYYY'),
                            confirmPassword: moment(item.birth_date_service_provider).format('YYYY')
                        }

                         axios.post(`${baseApiUrl}/signup`, user_service_provider)
                            .then(() => {
                                this.$toasted.global.defaultSuccess()
                                this.getLastUserTenant()
                            })
                            .catch(showError)
                },
            async getLastUserTenant() {
                const url = `${baseApiUrl}/serviceproviderbyuserid/${this.compan.id}/?name=${this.serviceprovider.name_service_provider}&email=${this.serviceprovider.email_service_provider}`;
                    await axios(url).then(
                        (res) =>
                        (this.serviceprovider = {
                            ...this.serviceprovider,
                            user_service_provider_id: res.data.id,
                        })
                    );

                    if(this.tenant.tenant_user_id_tenant > 0){
                        this.save()
                    }
            },  
           

        },
        mounted(){
            this.loadServiceProviders()
            this.loadDefaultServiceRequests()
            this.showTable = true
        }
}
</script>

<style>


    .serviceprovider-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .serviceprovider-search button{
        font-size: 0.75rem;
    }

     .serviceprovider-search select{
        font-size: 0.75rem;
    }

    .serviceprovider-search input{
        font-size: 0.75rem;
    }


    .serviceprovider-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }


    #modalActingService {
        font-size: 0.75rem;
    }

    #modalActingService button{
        font-size: 0.75rem;
    }

       #modalActingService select{
        font-size: 0.75rem;
    }

     #modalActingService input{
        font-size: 0.75rem;
    }

      #modalActingService label{
        font-size: 0.75rem;
        color: black;
    }

 

    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
